{
  "name": "275-tone Lumatone Scordatura Layout",
  "description": "This layout maps each of the 5 Lumatone blocks as a 55edo Bosanquet layout with one repeated note. The bottom rank follows the shape of instrument's geometry, presenting the diatonic notes beginning with A. The top rank might be thought of as the \"flats\", beginning with *fA, with an added *nF that is the duplicated note also present in the bottom rank. The 275 degree scale allows each key (with the exception of the 5 duplicated notes) to be tuned independently.",
  "scale": [
    "21.8",
    "43.6",
    "65.5",
    "87.3",
    "109.1",
    "130.9",
    "152.7",
    "174.5",
    "196.4",
    "218.2",
    "240.0",
    "261.8",
    "283.6",
    "305.5",
    "327.3",
    "349.1",
    "370.9",
    "392.7",
    "414.5",
    "436.4",
    "458.2",
    "480.0",
    "501.8",
    "523.6",
    "545.5",
    "567.3",
    "589.1",
    "610.9",
    "632.7",
    "654.5",
    "676.4",
    "698.2",
    "720.0",
    "741.8",
    "763.6",
    "785.5",
    "807.3",
    "829.1",
    "850.9",
    "872.7",
    "894.5",
    "916.4",
    "938.2",
    "960.0",
    "981.8",
    "1003.6",
    "1025.5",
    "1047.3",
    "1069.1",
    "1090.9",
    "1112.7",
    "1134.5",
    "1156.4",
    "1178.2",
    "1200.0",
    "1221.8",
    "1243.6",
    "1265.5",
    "1287.3",
    "1309.1",
    "1330.9",
    "1352.7",
    "1374.5",
    "1396.4",
    "1418.2",
    "1440.0",
    "1461.8",
    "1483.6",
    "1505.5",
    "1527.3",
    "1549.1",
    "1570.9",
    "1592.7",
    "1614.5",
    "1636.4",
    "1658.2",
    "1680.0",
    "1701.8",
    "1723.6",
    "1745.5",
    "1767.3",
    "1789.1",
    "1810.9",
    "1832.7",
    "1854.5",
    "1876.4",
    "1898.2",
    "1920.0",
    "1941.8",
    "1963.6",
    "1985.5",
    "2007.3",
    "2029.1",
    "2050.9",
    "2072.7",
    "2094.5",
    "2116.4",
    "2138.2",
    "2160.0",
    "2181.8",
    "2203.6",
    "2225.5",
    "2247.3",
    "2269.1",
    "2290.9",
    "2312.7",
    "2334.5",
    "2356.4",
    "2378.2",
    "2400.0",
    "2421.8",
    "2443.6",
    "2465.5",
    "2487.3",
    "2509.1",
    "2530.9",
    "2552.7",
    "2574.5",
    "2596.4",
    "2618.2",
    "2640.0",
    "2661.8",
    "2683.6",
    "2705.5",
    "2727.3",
    "2749.1",
    "2770.9",
    "2792.7",
    "2814.5",
    "2836.4",
    "2858.2",
    "2880.0",
    "2901.8",
    "2923.6",
    "2945.5",
    "2967.3",
    "2989.1",
    "3010.9",
    "3032.7",
    "3054.5",
    "3076.4",
    "3098.2",
    "3120.0",
    "3141.8",
    "3163.6",
    "3185.5",
    "3207.3",
    "3229.1",
    "3250.9",
    "3272.7",
    "3294.5",
    "3316.4",
    "3338.2",
    "3360.0",
    "3381.8",
    "3403.6",
    "3425.5",
    "3447.3",
    "3469.1",
    "3490.9",
    "3512.7",
    "3534.5",
    "3556.4",
    "3578.2",
    "3600.0",
    "3621.8",
    "3643.6",
    "3665.5",
    "3687.3",
    "3709.1",
    "3730.9",
    "3752.7",
    "3774.5",
    "3796.4",
    "3818.2",
    "3840.0",
    "3861.8",
    "3883.6",
    "3905.5",
    "3927.3",
    "3949.1",
    "3970.9",
    "3992.7",
    "4014.5",
    "4036.4",
    "4058.2",
    "4080.0",
    "4101.8",
    "4123.6",
    "4145.5",
    "4167.3",
    "4189.1",
    "4210.9",
    "4232.7",
    "4254.5",
    "4276.4",
    "4298.2",
    "4320.0",
    "4341.8",
    "4363.6",
    "4385.5",
    "4407.3",
    "4429.1",
    "4450.9",
    "4472.7",
    "4494.5",
    "4516.4",
    "4538.2",
    "4560.0",
    "4581.8",
    "4603.6",
    "4625.5",
    "4647.3",
    "4669.1",
    "4690.9",
    "4712.7",
    "4734.5",
    "4756.4",
    "4778.2",
    "4800.0",
    "4821.8",
    "4843.6",
    "4865.5",
    "4887.3",
    "4909.1",
    "4930.9",
    "4952.7",
    "4974.5",
    "4996.4",
    "5018.2",
    "5040.0",
    "5061.8",
    "5083.6",
    "5105.5",
    "5127.3",
    "5149.1",
    "5170.9",
    "5192.7",
    "5214.5",
    "5236.4",
    "5258.2",
    "5280.0",
    "5301.8",
    "5323.6",
    "5345.5",
    "5367.3",
    "5389.1",
    "5410.9",
    "5432.7",
    "5454.5",
    "5476.4",
    "5498.2",
    "5520.0",
    "5541.8",
    "5563.6",
    "5585.5",
    "5607.3",
    "5629.1",
    "5650.9",
    "5672.7",
    "5694.5",
    "5716.4",
    "5738.2",
    "5760.0",
    "5781.8",
    "5803.6",
    "5825.5",
    "5847.3",
    "5869.1",
    "5890.9",
    "5912.7",
    "5934.5",
    "5956.4",
    "5978.2",
    "32/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "55-Oliveros",
  "built_in_group": "Scordatura",
  "key_labels": "enumerate",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "0.0",
    "21.8",
    "43.6",
    "65.5",
    "87.3",
    "109.1",
    "130.9",
    "152.7",
    "174.5",
    "196.4",
    "218.2",
    "240.0",
    "261.8",
    "283.6",
    "305.5",
    "327.3",
    "349.1",
    "370.9",
    "392.7",
    "414.5",
    "436.4",
    "458.2",
    "480.0",
    "501.8",
    "523.6",
    "545.5",
    "567.3",
    "589.1",
    "610.9",
    "632.7",
    "654.5",
    "676.4",
    "698.2",
    "720.0",
    "741.8",
    "763.6",
    "785.5",
    "807.3",
    "829.1",
    "850.9",
    "872.7",
    "894.5",
    "916.4",
    "938.2",
    "960.0",
    "981.8",
    "1003.6",
    "1025.5",
    "1047.3",
    "1069.1",
    "1090.9",
    "1112.7",
    "1134.5",
    "1156.4",
    "1178.2",
    "1200.0",
    "1221.8",
    "1243.6",
    "1265.5",
    "1287.3",
    "1309.1",
    "1330.9",
    "1352.7",
    "1374.5",
    "1396.4",
    "1418.2",
    "1440.0",
    "1461.8",
    "1483.6",
    "1505.5",
    "1527.3",
    "1549.1",
    "1570.9",
    "1592.7",
    "1614.5",
    "1636.4",
    "1658.2",
    "1680.0",
    "1701.8",
    "1723.6",
    "1745.5",
    "1767.3",
    "1789.1",
    "1810.9",
    "1832.7",
    "1854.5",
    "1876.4",
    "1898.2",
    "1920.0",
    "1941.8",
    "1963.6",
    "1985.5",
    "2007.3",
    "2029.1",
    "2050.9",
    "2072.7",
    "2094.5",
    "2116.4",
    "2138.2",
    "2160.0",
    "2181.8",
    "2203.6",
    "2225.5",
    "2247.3",
    "2269.1",
    "2290.9",
    "2312.7",
    "2334.5",
    "2356.4",
    "2378.2",
    "2400.0",
    "2421.8",
    "2443.6",
    "2465.5",
    "2487.3",
    "2509.1",
    "2530.9",
    "2552.7",
    "2574.5",
    "2596.4",
    "2618.2",
    "2640.0",
    "2661.8",
    "2683.6",
    "2705.5",
    "2727.3",
    "2749.1",
    "2770.9",
    "2792.7",
    "2814.5",
    "2836.4",
    "2858.2",
    "2880.0",
    "2901.8",
    "2923.6",
    "2945.5",
    "2967.3",
    "2989.1",
    "3010.9",
    "3032.7",
    "3054.5",
    "3076.4",
    "3098.2",
    "3120.0",
    "3141.8",
    "3163.6",
    "3185.5",
    "3207.3",
    "3229.1",
    "3250.9",
    "3272.7",
    "3294.5",
    "3316.4",
    "3338.2",
    "3360.0",
    "3381.8",
    "3403.6",
    "3425.5",
    "3447.3",
    "3469.1",
    "3490.9",
    "3512.7",
    "3534.5",
    "3556.4",
    "3578.2",
    "3600.0",
    "3621.8",
    "3643.6",
    "3665.5",
    "3687.3",
    "3709.1",
    "3730.9",
    "3752.7",
    "3774.5",
    "3796.4",
    "3818.2",
    "3840.0",
    "3861.8",
    "3883.6",
    "3905.5",
    "3927.3",
    "3949.1",
    "3970.9",
    "3992.7",
    "4014.5",
    "4036.4",
    "4058.2",
    "4080.0",
    "4101.8",
    "4123.6",
    "4145.5",
    "4167.3",
    "4189.1",
    "4210.9",
    "4232.7",
    "4254.5",
    "4276.4",
    "4298.2",
    "4320.0",
    "4341.8",
    "4363.6",
    "4385.5",
    "4407.3",
    "4429.1",
    "4450.9",
    "4472.7",
    "4494.5",
    "4516.4",
    "4538.2",
    "4560.0",
    "4581.8",
    "4603.6",
    "4625.5",
    "4647.3",
    "4669.1",
    "4690.9",
    "4712.7",
    "4734.5",
    "4756.4",
    "4778.2",
    "4800.0",
    "4821.8",
    "4843.6",
    "4865.5",
    "4887.3",
    "4909.1",
    "4930.9",
    "4952.7",
    "4974.5",
    "4996.4",
    "5018.2",
    "5040.0",
    "5061.8",
    "5083.6",
    "5105.5",
    "5127.3",
    "5149.1",
    "5170.9",
    "5192.7",
    "5214.5",
    "5236.4",
    "5258.2",
    "5280.0",
    "5301.8",
    "5323.6",
    "5345.5",
    "5367.3",
    "5389.1",
    "5410.9",
    "5432.7",
    "5454.5",
    "5476.4",
    "5498.2",
    "5520.0",
    "5541.8",
    "5563.6",
    "5585.5",
    "5607.3",
    "5629.1",
    "5650.9",
    "5672.7",
    "5694.5",
    "5716.4",
    "5738.2",
    "5760.0",
    "5781.8",
    "5803.6",
    "5825.5",
    "5847.3",
    "5869.1",
    "5890.9",
    "5912.7",
    "5934.5",
    "5956.4",
    "5978.2"
  ],
  "note_colors": [
    "ffb8b8",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffdbdb",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "#ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffdbdb",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffdbdb",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffdbdb",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0",
    "ffffff",
    "d8f7fd",
    "ddfde3",
    "bab4c0",
    "adadad",
    "b5a5ca",
    "ada5c0",
    "f5ffe0",
    "fbf6e0"
  ],
  "equivSteps": 275,
  "fundamental": 220,
  "reference_degree": 220,
  "center_degree": 220,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 36,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 19,
  "lumatone_anchor_channel": 3
}
